import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SecureComponent } from './secure/secure.component';
import { CallbackComponent } from './core/callback/callback.component';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { CreateTagDialogComponent } from './shared/components/create-tag-dialog/create-tag-dialog.component';
import { CreateClienteDialogComponent } from './shared/components/create-cliente-dialog/create-cliente-dialog.component';
import { CreateCommessaDialogComponent } from './shared/components/create-commessa-dialog/create-commessa-dialog.component';
import { SupportTicketDialogComponent } from './shared/components/support-ticket-dialog/support-ticket-dialog.component';
import { LeafletMapComponent } from './shared/components/leaflet-map/leaflet-map.component';
import { PosizioneReferenzaDialogComponent } from './shared/components/posizione-referenza-dialog/posizione-referenza-dialog.component';
import { HomeComponent } from './pages/home/home.component';
import { LandingComponent } from './pages/landing/landing.component';
import { NuovaReferenzaWizardComponent } from './pages/home/nuova-referenza-wizard/nuova-referenza-wizard.component';
import { TagsComponent } from './pages/tags/tags.component';
import { ClientiComponent } from './pages/clienti/clienti.component';
import { CommesseComponent } from './pages/commesse/commesse.component';
import { RuoliReferenzaComponent } from './pages/ruoli-referenza/ruoli-referenza.component';

/* PrimeNG moduli base (puoi aggiungerne altri in seguito) */
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { MessageService, ConfirmationService } from 'primeng/api';

/* Auth0 */
import { AuthModule, AuthHttpInterceptor } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { AuthErrorInterceptor } from './core/interceptors/auth-error.interceptor';

/* Logger */
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';

@NgModule({
  declarations: [
    AppComponent,
    SecureComponent,
    CallbackComponent,
    NavbarComponent,
    FooterComponent,
    CreateTagDialogComponent,
    CreateClienteDialogComponent,
    CreateCommessaDialogComponent,
    SupportTicketDialogComponent,
    LeafletMapComponent,
    PosizioneReferenzaDialogComponent,
    HomeComponent,
    LandingComponent,
    NuovaReferenzaWizardComponent,
    TagsComponent,
    ClientiComponent,
    CommesseComponent,
    RuoliReferenzaComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    MenubarModule,
    ButtonModule,
    CardModule,
    ToastModule,
    MenuModule,
    TooltipModule,
    TableModule,
    InputTextModule,
    InputTextareaModule,
    AutoCompleteModule,
    InputSwitchModule,
    DialogModule,
    StepsModule,
    CalendarModule,
    InputNumberModule,
    ChipsModule,
    DropdownModule,
    MultiSelectModule,
    ConfirmDialogModule,
    FileUploadModule,
    CheckboxModule,
    TabViewModule,
    AuthModule.forRoot({
      domain: environment.auth.domain,
      clientId: environment.auth.clientId,
      authorizationParams: {
        audience: environment.auth.audience,
        redirect_uri: environment.auth.redirectUri,
        scope: 'openid profile email offline_access', // offline_access è necessario per i refresh token
      },
      cacheLocation: 'localstorage', // Usa localStorage invece di sessionStorage per persistenza tra reload
      useRefreshTokens: true, // Abilita refresh token per mantenere la sessione attiva
      useRefreshTokensFallback: true, // Fallback silenzioso se il refresh token non è in cache
      sessionCheckExpiryDays: 7, // Controlla la sessione per 7 giorni
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.backend.baseUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth.audience,
              },
            },
          },
        ],
      },
      skipRedirectCallback: false,
    }),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.ERROR,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthErrorInterceptor,
      multi: true,
    },
    MessageService,
    ConfirmationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
